<app-add-tickets  [type]="type" [id]="id" [prospect]="prospect_id" [fromDetails]="fromDetails"></app-add-tickets>